export default "__VITE_ASSET__CGP8UoHt__"